export default "__VITE_ASSET__CBTwhsen__"